import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './Footer.css';


class Footer extends Component {
  render() {
    return (
      <Navbar className="footer-navbar" bg="dark" variant="dark" expand="lg">
        <div className="copyright text-center" >
          ©{(new Date().getFullYear())}, Megadigm. All rights reserved
        </div>
        <Navbar.Toggle aria-controls="footer-links"/>
        <Navbar.Collapse id="footer-links" className="justify-content-end">
          <Nav>
            <Nav.Link href="/provacypolicy">Privacy Policy</Nav.Link>
            <Nav.Link href="/termsandconditions">Terms & Conditions</Nav.Link>
            <Nav.Link href="/termsandconditions">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Footer;